import type { ReactNode } from "react";

interface Props {
  onClick: () => void;
}

/// "Revert to my notes" affordance under the textarea. Small tertiary link
/// (type="button" so it never submits the surrounding form). Shared by the
/// feedback and kudos compose dialogs (spec decision 2).
export function WritingAssistRevertLink({ onClick }: Props): ReactNode {
  return (
    <div className="-mt-2 flex justify-end">
      <button
        type="button"
        className="text-xs text-text-tertiary underline underline-offset-2 hover:text-text-secondary"
        onClick={onClick}
      >
        Revert to my notes
      </button>
    </div>
  );
}
